import $http from '../connectionProxy'
import * as parent from './responsibleParent'
import * as student from './responsibleStudent'

export const getByDocument = document => $http.get(`/responsibles_area/responsibles/search_document?q=${document}`)

export const update = (responsibleId, data) => $http.patch(`/responsibles_area/responsibles/${responsibleId}/`, data)

export {
  parent,
  student
}
